import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCircle"><Path fillRule="evenodd" clipRule="evenodd" d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20H13V22H12C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 15.0376 19.5376 17.5 16.5 17.5C13.4624 17.5 11 15.0376 11 12V11H13V12C13 13.933 14.567 15.5 16.5 15.5C18.433 15.5 20 13.933 20 12C20 7.58172 16.4183 4 12 4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCircle;
